import React from 'react';

import './style.scss';
import { CoreLink, ImageFromField } from '@uncinc/react-drupal-core';

const TaxonomyMilestoneTeaser = ({ entity }) => {
  const image = entity.getIn(['field_media_image', 0, 'styles', 'dossier_card']);
  const label = entity.getIn(['field_milestone_label', 0, 'value'], '');
  const link = entity.getIn(['paths', 'nl']);
  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['field_sub_title', 0, 'value'], '');
  return (
    <CoreLink to={link} className="Milestone__info__link no-underline font-normal">
      <div className="Milestone__image">
        <ImageFromField className="Milestone__image__image" src={image} />
      </div>
      <div className="Milestone__info">
        <div className="Milestone__info__label">{ label }</div>
        <i className="icon icon-after icon-arrow-right" />
        <h5 className="Milestone__info__title">{ title }</h5>
        <div className="Milestone__info__body">{ body }</div>
      </div>
    </CoreLink>
  );
};

export default TaxonomyMilestoneTeaser;
